const createApiConfig = (config) => ({
  apiUrl: config.apiUrl,
  cartsUrl: config.cartsUrl || `${config.apiUrl}/carts`,
  locationsUrl: config.locationsUrl || `${config.apiUrl}/locations`,
  ordersUrl: config.ordersUrl || `${config.apiUrl}/orders`,
  paymentsUrl: config.paymentsUrl || `${config.apiUrl}/payments`,
  productsUrl: config.productsUrl || `${config.apiUrl}/products`,
  storesUrl: config.storesUrl || `${config.apiUrl}/stores`,
  subscriptionsUrl: config.subscriptionsUrl || `${config.apiUrl}/subscriptions`
});
export {
  createApiConfig
};
//# sourceMappingURL=create-api-config.js.map
